import React from "react";
import { ISearchBreadCrumbProps } from "./SearchBreadCrumbProps";
import CustomBreadCrumb from "../CustomBreadCrumb/CustomBreadCrumb";
import { CHECKOUT_STEPS } from "../../../@types/Constants";
import {
  showNewCheckoutExperienceDesktop,
  showNewCheckoutExperienceMobile,
} from "../../../utils/helpers";
import { useMobileDetectContext } from "../../../context/MobileDetectContext";
import { useShowNewCheckoutExperienceDesktop } from "../../../hooks/useShowNewCheckoutExperienceDesktop";
import { useShowNewCheckoutExperienceMobile } from "../../../hooks/useShowNewCheckoutExperienceMobile";

const SearchBreadCrumb: React.FC<ISearchBreadCrumbProps> = ({
  step,
  location,
  hotel,
  handleGoToGuestDetailsStep,
}) => {
  const { isMobileOnly } = useMobileDetectContext();

  const SHOW_NEW_CHECKOUT_EXPERIENCE_DESKTOP =
    useShowNewCheckoutExperienceDesktop();
  const SHOW_NEW_CHECKOUT_EXPERIENCE_MOBILE =
    useShowNewCheckoutExperienceMobile();
  const useOldCheckout =
    (!SHOW_NEW_CHECKOUT_EXPERIENCE_DESKTOP && !isMobileOnly) ||
    (!SHOW_NEW_CHECKOUT_EXPERIENCE_MOBILE && isMobileOnly);

  const crumbs = [
    {
      text: "Select Room",
      page: "",
      id: "select-room",
    },
    {
      text: useOldCheckout ? "Guest Details" : "Select Rate",
      page: "/checkout",
      id: useOldCheckout ? "guest-details" : CHECKOUT_STEPS.SELECT_RATE,
    },
    {
      text: "Checkout",
      page: "/checkout",
      id: "checkout",
    },
  ];

  if (step === "2") {
    return <></>; // hides breadcrumb on hotel pages
  }

  return (
    <CustomBreadCrumb
      crumbs={crumbs}
      step={step}
      location={location}
      hotel={hotel}
      handleGoToGuestDetailsStep={handleGoToGuestDetailsStep}
    />
  );
};

export default SearchBreadCrumb;
